import { Quote, Star } from "lucide-react";

const TESTIMONIALS = [
  {
    name: "Aanya R.",
    role: "Plan‑managed participant, Sydney",
    quote:
      "For the first time we feel heard. Our support worker actually knows our routine and treats Mum with so much dignity.",
  },
  {
    name: "Jacob H.",
    role: "Self‑managed participant, Melbourne",
    quote:
      "From the first phone call, Guiding Support felt different — calm, human, and clear about what they could offer me.",
  },
  {
    name: "Priya & Family",
    role: "Family member, Brisbane",
    quote:
      "They helped us untangle the NDIS and matched us with someone our son genuinely looks forward to seeing every week.",
  },
];

export default function Testimonials() {
  return (
    <section
      id="testimonials"
      data-testid="testimonials-section"
      className="py-20 md:py-28 bg-brand-sand/60"
    >
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-16">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-6">
          <div className="max-w-2xl">
            <span className="text-xs uppercase tracking-[0.22em] text-brand-terracotta font-semibold">
              Stories from our community
            </span>
            <h2 className="mt-3 font-heading font-semibold tracking-tight text-brand-forest text-3xl sm:text-4xl lg:text-5xl">
              Real people. Real support. Real difference.
            </h2>
          </div>
          <div className="flex items-center gap-1.5 text-brand-forest">
            {Array.from({ length: 5 }).map((_, i) => (
              <Star key={i} className="h-5 w-5 fill-brand-terracotta text-brand-terracotta" />
            ))}
            <span className="ml-2 text-sm text-brand-muted">4.9 average from 240+ reviews</span>
          </div>
        </div>

        <div className="mt-12 grid md:grid-cols-3 gap-6">
          {TESTIMONIALS.map((t, i) => (
            <figure
              key={i}
              data-testid={`testimonial-${i}`}
              className="bg-white rounded-2xl border border-brand-sand p-8 shadow-sm flex flex-col"
            >
              <Quote className="h-8 w-8 text-brand-terracotta/70" />
              <blockquote className="mt-5 text-base leading-relaxed text-brand-ink flex-1">
                “{t.quote}”
              </blockquote>
              <figcaption className="mt-6 pt-6 border-t border-brand-sand">
                <p className="font-semibold text-brand-ink">{t.name}</p>
                <p className="text-xs text-brand-muted">{t.role}</p>
              </figcaption>
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
}
